import React, {Component} from 'react';
import ReactDOM from "react-dom";

import firebase from "./../firebase";
//import $ from 'jquery';
import './jquery.dataTables.min.css';
import { getDatabase,onValue, ref, orderByChild, equalTo, get, set, child, update,query,push,remove } from "firebase/database";

import $ from 'jquery';
import moment from 'moment';
import Select from 'react-select';

$.DataTable = require('datatables.net');

export default class Users extends Component {
    constructor(props) {
        super(props);
        this.state = {
            user: [],
            role: '',
            count:0,
            datatable: [],
            count_logs: 0,
            myip: '',
            mylocation: '',
            users: [],
            setuserid: '',
            selectoption: [
              {value:1,label:"demo"}
            ],
            selectoptions: [
                {value:1,label:"demo"},
                {value:2,label:"admin"},
                {value:3,label:"adminc"},
                {value:4,label:"adminf"},
            ]
        };
    }

    componentDidMount() {
      //alert(localStorage.getItem('user_id'))
      this.logs();
      this.getUser();
      this.getUsers();
      this.setdatatable();
    }

    //componentWillUnmount(){
    //  this.$el.DataTable.destroy(true);
    //}

    logs = () => {
      //alert('Did Logs');
      const db = getDatabase();
      get(ref(db,"logs")).then((snapshot)=>{
        var select_logs = []
        snapshot.forEach(child => {
          var data = child.val()
          select_logs.push({
              id: data.id,
              status: data.status,
              message: data.message,
              agent: data.agent,
              ip: data.ip,
              location: data.location,
              user_id: data.user_id,
              time: data.time,
            })
        this.setState({ count_logs: select_logs.length })
        
        })
      })
      fetch('https://ipapi.co/json')
        .then(res => res.json())
        .then((data) => {
          //alert(JSON.stringify(data.ip))
            setTimeout(function(){ 
              this.setState({ myip: data.ip, mylocation: data.country_name+'#'+data.region })
            }.bind(this), 200);
  
      setTimeout(function(){ 
      //alert(JSON.stringify(this.state.count_logs));
      var curtime = moment().format("DD/MM/YYYY HH:mm:ss");
      /*var refdb = firebase.database().ref('/logs').push();
      refdb = refdb.toString().slice(-20);
      
      let updateData = firebase.database().ref("/logs").child(refdb);
      updateData.child("id").set(this.state.count_logs+1);
      updateData.child("status").set('1');
      updateData.child("message").set('User Access Users Page');
      updateData.child("agent").set(navigator.userAgent);
      updateData.child("ip").set(this.state.myip);
      updateData.child("location").set(this.state.mylocation);
      updateData.child("user_id").set(localStorage.getItem('user_id'));
      updateData.child("time").set(curtime);*/
      var refdb = push(ref(db,'/logs'));
      //refdb_ref = refdb.toString().slice(-20);
      
      fetch('https://ipapi.co/json')
        .then(res => res.json())
        .then((dataipres) => {
          //let updateData = ref(db,"logs/"+refdb);
          set(refdb,{
            id:this.state.count_logs+1,
            status:'1',
            message:'User Access Users Page',
            agent:String(navigator.userAgent),
            ip: String(dataipres.ip),
            location:String(dataipres.country_name+'#'+dataipres.region),
            user_id:String(localStorage.getItem('user_id')),
            time:String(curtime)
          });
      });
      }.bind(this), 400);
    })

    }

    setdatatable = () => {
      setTimeout(function(){
        this.$el = $(this.el)
        this.$el.DataTable({
          data: this.state.datatable,
          columns: [
            {"title": "ID","data": "id"},
            {"title": "Name","data": "name"},
            {"title": "Nick Name","data": "nickname"},
            {"title": "Email","data": "email"},
            {"title": "Phone","data": "phone"},
            {"title": "Role","data": "role"},
            {"title": "Status","data": "status"},
            {"title": "Time","data": "time"},
            {"title": "Set Role","data": "setrole"},
          ],
          columnDefs: [
              {
             targets: [8],
             minwidth: 180,
             className: "center",
             createdCell: (td, cellData, rowData) =>
             ReactDOM.render(
                 <div style={{'width':'150px'}}>
                 <Select
                  className="select2"
                  name="form-field-name"
                  value={this.state.selectoption}
                  options={this.state.selectoptions}
                  onChange={this.setselectoption}
                  />
                  <button
                    className = "btn btn-warning"
                    id={rowData.id}
                    onClick={() => {
                    this.usersetrole(rowData.email);
                    }}
                   > Set Role </button></div>, td ), 
                  },
          ]
        })
        }.bind(this), 1000); 
    }

    getUser = () => {
      
      /*firebase.database().ref("/users").orderByChild('email')
      .equalTo(localStorage.getItem('user_id')).on('value', snapshot => {*/
      const db = getDatabase();
      get(query(ref(db, 'users'), orderByChild('email'),equalTo(localStorage.getItem('user_id')))).then((snapshot)=>{
        var userg = []
        snapshot.forEach(child => {
          var data = child.val()
        userg.push({
          id: data.key, 
          email: data.email,
          name: data.name,
          nickname: data.nickname,
          phone: data.phone,
          role: data.role,
          time: data.time
        })
        this.setState({ user: userg })
      })
        
      })
      setTimeout(function(){ 
        this.setState({ role: JSON.stringify(this.state.user[0].role) })
        //alert(JSON.stringify(this.state.role))
      //alert(JSON.stringify(this.state.user[0].role))   
      }.bind(this), 500);   
    }

    getUsers = () => {
      setTimeout(function(){ 
        if(this.state.user[0].role==='admin'){
        //alert(this.state.messages)
        /*var messagesDB = firebase
          .database()
          .ref("/users")
        messagesDB.on("value", snapshot => {*/
        const db = getDatabase();
        get(ref(db,"users")).then((snapshot)=>{
          let newChannels = []
          let newDatatable = []
          snapshot.forEach(child => {
            var channel = child.val()
            newChannels.push({ id: channel.id, name: channel.name, nickname: channel.nickname, email: channel.email, phone: channel.phone, role: channel.role, status: channel.status, time: channel.time })
            newDatatable.push({ id: channel.id, name: channel.name, nickname: channel.nickname, email: channel.email, phone: channel.phone, role: channel.role, status: channel.status, time: channel.time, setrole: '' })
          })

          this.setState({ users: newChannels })
          this.setState({ datatable: newDatatable })

        })
        }

      }.bind(this), 500); 
      }

    usersetrole = (val) => {
        //alert(val);
        //alert(this.state.selectoption);
        /*firebase.database().ref("/users").on('value', snapshot => {*/
        const db = getDatabase();
        get(ref(db,"users")).then((snapshot)=>{
            snapshot.forEach(child => {
              var data = child.val()
              if(data.email === val){
                //alert(child.key);
                firebase.database().ref("/users").child(child.key).update({role:this.state.selectoption.label}).then(() => {
                    //this.setState({ users: []}); 
                    //this.forceUpdate();
                    //alert('S-a facut!');
                    //$('#datatable').data.reload();
                    //this.el.data.reload();
                    //this.componentDidMount();
                    setTimeout(function(){
                      //this.setState({ datatable: []}); 
                      //alert(this.state.datatable);
                        this.forceUpdate();
                        //this.getUsers();
                        //this.$el = $(this.el)
                        //this.$el.DataTable.ajax.reload();
                        //$('#datatable').DataTable().ajax.reload();
                       // this.render();
                    }.bind(this), 300); 
                  }).catch(error => {
                    return {
                      errorCode: error.code,
                      errorMessage: error.message
                    }
                  });
                //this.setState({ selectoption: ''}); 
                //this.forceUpdate();
                //window.location.reload();
                //this.setState({ users: []}); 
                //this.getUsers();
                //this.forceUpdate();
              }
            })
        });  
        setTimeout(function(){
          //this.setState({}); 
          //alert(this.state.datatable);
          $('#datatable').DataTable().destroy();
          //$('#datatable').remove();
          //ReactDOM.render(<table id="datatable" className="display" width="100%" ref={el => this.el = el }></table>);
          //$('#datatable').DataTable().empty();
          //$('#datatable').DataTable().ajax.reload();
          this.forceUpdate();
          this.getUsers();
          this.setdatatable();
          $('#datatable').show();
            //this.$el = $(this.el)
            //this.$el.DataTable.ajax.reload();
            //$('#datatable').DataTable().ajax.reload();
           // this.render();
        }.bind(this), 300); 
    }

    setselectoption = (val) => {
        //this.setState({ selectoption: val }) 
        //alert(JSON.stringify(val));
        this.setState({ selectoption: val }); 
    }

    render(){
        const divStyled={
            overflowY: 'scroll',
            border:'1px solid red',
            float: 'left',
            height:'162px',
            position:'relative',
            marginBottom: '30px'
          };
          const divStyle={
            overflowY: 'scroll',
            border:'1px solid red',
            float: 'left',
            height:'500px',
            position:'relative',
            marginBottom: '30px'
          };
          const divStyless={  
            height:'150px',
          };
        return (
            <main role="main" className="col-md-9 ml-sm-auto col-lg-12 pt-3 px-4">
            <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pb-2 mb-3 border-bottom">
              <h1 className="h2">Users Page</h1>
            </div>
            <p>Users Page</p>

            <table id="datatable" className="display" width="100%" ref={el => this.el = el }></table>

            <div className="modal" id="myModal">
              <div className="modal-dialog">
                <div className="modal-content">

                  <div className="modal-header">
                    <h4 className="modal-title">Modal Heading</h4>
                    <button type="button" className="close" data-dismiss="modal">&times;</button>
                  </div>

                  <div className="modal-body">
                  
                  </div>

                  <div className="modal-footer">
                    <button type="button" className="btn btn-danger" data-dismiss="modal">Close</button>
                  </div>

                </div>
              </div>
            </div>

            <div style={divStyless}></div>
          </main>  
        )
    }
}